import React from "react";
import PropTypes from "prop-types";

import Accordion from "../../../../components/common/Accordion";

import * as S from "./FaqSection.style";

const FaqSection = ({ faqTitle, faqList }) => {
  const listItems = Array.isArray(faqList) ? faqList : [];

  return (
    <S.FaqSectionContainer>
      <S.FaqSectionContent className="container">
        <S.FaqSectionHeader>
          <S.FaqSectionTitle>
            Dúvidas sobre o seguro {faqTitle || null}
          </S.FaqSectionTitle>
        </S.FaqSectionHeader>

        <S.FaqSectionList>
          <Accordion
            className="accordion-list"
            listItems={listItems.slice(0, 6)}
          />
          <Accordion
            className="accordion-list"
            listItems={listItems.slice(6, listItems.length)}
          />
        </S.FaqSectionList>
      </S.FaqSectionContent>
    </S.FaqSectionContainer>
  );
};

FaqSection.propTypes = {
  faqTitle: PropTypes.string,
  faqList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      body: PropTypes.node.isRequired,
    })
  ),
};

FaqSection.defaultProps = {
  faqTitle: "",
  faqList: [],
};

export default FaqSection;
